import type { EffectiveStatus } from "@/api/profile";

/** The dot beside a person: its colour is the status, and the status is also written as its label. */
export function statusDotClass(status: EffectiveStatus | undefined): string {
  switch (status) {
    case "working":
      return "bg-success";
    case "break":
      return "bg-warning";
    case "off":
      return "bg-ink-subtle";
    default:
      return "hidden";
  }
}
